import schoolStatsIcon from '@/assets/icons/schoolStats.svg';
import schoolStatsIconPending from '@/assets/icons/schoolStatsPending.svg';
import { useSchools } from './schools.hook';
import StatCard from '@/components/Views/StatCard/StatCard';

const SchoolsStatistics = () => {
  const { schoolStats } = useSchools();

  const stats = [
    {
      icon: schoolStatsIcon,
      title: 'Ecole Totales',
      value: schoolStats?.totalSchools,
    },
    {
      icon: schoolStatsIcon,
      title: 'Ecole Privée',
      value: schoolStats?.totalPrivate,
    },
    {
      icon: schoolStatsIcon,
      title: 'Ecole Publique',
      value: schoolStats?.totalPublic,
    },
    {
      icon: schoolStatsIconPending,
      title: 'Ecole en attentes',
      value: schoolStats?.totalPending,
      valueColor: 'text-[#FF5500]',
    },
  ];

  return (
    <div className="grid grid-cols-4 gap-4 mb-16">
      {stats.map(({ icon, title, value, valueColor }, index) => (
        <StatCard
          key={index}
          icon={icon}
          title={title}
          value={value || 0}
          valueColor={valueColor}
        />
      ))}
    </div>
  );
};

export default SchoolsStatistics;
